import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../../_auth/AuthContext';
import { IUserState } from '../../_types/user';
import { IChangeEventHandler } from '../../_types/nav';
import { Select, InputLabel } from '@material-ui/core';
import { QueryDefinition } from '../../_types/reports';

interface Props {
    onChange: IChangeEventHandler<QueryDefinition | null>;
    initialValue: string;
};



const QuerySelector: React.FC<Props> = (prop: Props) => {
    const {user }: IUserState = useContext(AuthContext);
    const [querySelection, setQuerySelection] = useState<string>('');
    const [queries, setQueries] = useState<QueryDefinition[]>([]);

    const _resolveQueryies = () => {
        let userAuth = (user.authorized === true);
        let noLocation = user.currentLocation === null || user.currentLocation === undefined;

        //any permissions

        let queried = [
            { cn:"location", description: "Location: General", permitted: userAuth },
            { cn:"user", description: "User: General", permitted: !noLocation && userAuth },
            { cn:"membership", description: "Membership: General", permitted: userAuth }
        ]

        setQueries(queried);
    }
    React.useEffect(() => {

        _resolveQueryies();

    }, [])

 
    React.useEffect(() => {

        _resolveQueryies();
        setQuerySelection('');
        prop.onChange(null);
            
    }, [user]);

    const handleQuerySelection = (event: React.ChangeEvent<{ value: unknown }>) => {
        let selection = event.target.value as string;

        

        let queryDef = queries.find(q => q.cn === selection);

        setQuerySelection((orig) => { return selection; });

        if (queryDef) {
            
            prop.onChange(queryDef);
        }
    }
/*
selector
field selector (select fields, sorts)
query builder 
results viewer (paging / download)

*/

return (
    <React.Fragment>
        <InputLabel id="type-select-label">Select Query</InputLabel>
        <Select id="query-select" fullWidth labelId="type-select-label" label="Select Query" value={querySelection} onChange={handleQuerySelection}>
            {  queries.map(m => {
                    if (m.permitted) {
                        return (<option value={m.cn}>{m.description}</option>)
                    } else {
                        return (<span></span>)
                    }
                })
            }
        </Select>
    </React.Fragment>
)
}

export default QuerySelector;